import { htmlDir, languageSelectOptions } from '../marketplace-custom-config';

export const setDocumentDirection = lang => {
  if (typeof document !== 'undefined') {
    const dir = languageSelectOptions[lang].dir;
    document.documentElement.setAttribute('dir', dir);
    const prevClass = dir === htmlDir.ltr ? htmlDir.rtl : htmlDir.ltr;
    document.body.classList.add(dir);
    document.body.classList.remove(prevClass);
  }
};

export const isRtlLang = lang => {
  const dir = languageSelectOptions[lang]?.dir || htmlDir.ltr;
  return dir === htmlDir.rtl;
};
